import type { LucideIcon } from 'lucide-react';

// Benefit/feature card: icon tile + heading + short copy. Used in the homepage
// benefits grid and reusable across public marketing pages.
export function FeatureCard({
  icon: Icon,
  title,
  children,
}: {
  icon: LucideIcon;
  title: string;
  children: string;
}) {
  return (
    <div className="rounded-2xl border border-zinc-200 dark:border-zinc-800 bg-white dark:bg-zinc-900 p-6 space-y-3">
      <span className="inline-flex items-center justify-center w-11 h-11 rounded-xl bg-violet-50 dark:bg-violet-950/40 text-violet-600 dark:text-violet-400">
        <Icon className="w-5 h-5" aria-hidden />
      </span>
      <h3 className="text-base font-semibold text-zinc-900 dark:text-zinc-50">{title}</h3>
      <p className="text-sm text-zinc-600 dark:text-zinc-400 leading-relaxed">{children}</p>
    </div>
  );
}
